import {
  RoomBookingIcon_default
} from "./chunk-X6FECYZ5.mjs";
export {
  RoomBookingIcon_default as default
};
